import { FunctionComponent } from 'react'
import Sections from './modals/sections/sections'
import Groups from './modals/group/group'
import { Daycare, DaycareType } from '@/types/Daycare'
import Alert from './modals/alert'
import Places from './modals/places'
import profileStyles from '../DaycareProfileHandler.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import FamiliesIcon from '@mui/icons-material/SupervisedUserCircle'
import { useAuth } from '@/modules/context/AuthContext.tsx'

interface DaycareSettingsProps {
    daycare: Daycare
}

const DaycareSettings: FunctionComponent<DaycareSettingsProps> = ({ daycare }: DaycareSettingsProps) => {
    const { user } = useAuth()

    const { t } = useTranslation()

    const navigate: NavigateFunction = useNavigate()

    const canUpdate: boolean = user?.currentDaycareRights.canWriteParamsDaycare || false
    const isRPEOrLAEP: boolean = daycare.type === DaycareType.laep || daycare.type === DaycareType.rpe

    return (
        <div className={profileStyles.PagePosition}>
            <Sections daycare={daycare} canUpdate={canUpdate} />
            <Groups />
            <Alert daycare={daycare} canUpdate={canUpdate} />
            <Places />
            {user?.currentDaycareRights.canReadFamilies && (
                <ButtonTextIcon
                    type={'custom'}
                    customText={isRPEOrLAEP ? t('showPublicList') : t('showFamilyList')}
                    customIcon={<FamiliesIcon />}
                    onClick={() => navigate('/adults')}
                />
            )}
        </div>
    )
}

export default DaycareSettings
